import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PublisherApiService from "../../ApiServices/PublisherApiService/PublisherApiService";
import WebsiteApiService from "../../ApiServices/WebsiteApiService/WebsiteApiService";
import AppApiService from "../../ApiServices/WebsiteApiService/AppApiService";

const AssignedAdsCode = ({ isOpen, onClose }) => {
    const [publishers, setPublishers] = useState([]);
    const [websites, setWebsites] = useState([]);
    const [apps, setApps] = useState([]);
    const [formData, setFormData] = useState({
        UserId: "",
        platformType: "web",
        WebsiteId: "",
        Id: "",
    });

    useEffect(() => {
        fetchPublishers();
    }, []);

    const fetchPublishers = async () => {
        try {
            const response = await PublisherApiService.getAllApproved();
            setPublishers(response.data || []);
        } catch (error) {
            toast.error("Failed to load publishers");
        }
    };

    const fetchWebsites = async (publisherId) => {
        if (!publisherId) {
            setWebsites([]);
            return;
        }
        try {
            const response = await WebsiteApiService.GetAllWebByUserId(publisherId);
            setWebsites(response.data || []);
        } catch (error) {
            toast.error("Failed to load websites");
        }
    };

    const fetchApps = async (publisherId) => {
        if (!publisherId) {
            setApps([]);
            return;
        }
        try {
            const response = await AppApiService.GetAllAppByUserId(publisherId);
            setApps(response.data || []);
        } catch (error) {
            toast.error("Failed to load apps");
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            WebsiteId: formData.WebsiteId || null,
            AppId: formData.Id || null,
            PublisherId: formData.UserId,
        };

        try {
            const response = await PublisherApiService.AssignAdsCode(payload);
            if (response.isSuccess) {
                toast.success("Ad Code Assigned Successfully");
                if (onClose) onClose();  // Ensure modal closes
            } else {
                toast.error("Failed to assign Ad Code.");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Error assigning Ad Code.");
            console.error(error);
        }
    };

    const handlePublisherChange = (e) => {
        const publisherId = e.target.value;
        setFormData((prev) => ({ ...prev, UserId: publisherId, WebsiteId: "", AppId: "" }));
        fetchWebsites(publisherId);
        fetchApps(publisherId);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-xl font-bold mb-4">Assign Ad Code</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="text-gray-600">Select Publisher</label>
                        <select
                            name="UserId"
                            value={formData.UserId}
                            onChange={handlePublisherChange}
                            className="w-full p-2 border rounded"
                        >
                            <option value="">Select Publisher</option>
                            {publishers.map((pub) => (
                                <option key={pub.id} value={pub.id}>
                                    {pub.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="flex space-x-4">
                        <label className="flex items-center">
                            <input
                                type="radio"
                                name="platformType"
                                value="web"
                                checked={formData.platformType === "web"}
                                onChange={handleInputChange}
                                className="mr-2"
                            />
                            Web
                        </label>
                        <label className="flex items-center">
                            <input
                                type="radio"
                                name="platformType"
                                value="app"
                                checked={formData.platformType === "app"}
                                onChange={handleInputChange}
                                className="mr-2"
                            />
                            App
                        </label>
                    </div>

                    {formData.platformType === "web" && (
                        <div>
                            <label className="text-gray-600">Select Website</label>
                            <select
                                name="WebsiteId"
                                value={formData.WebsiteId}
                                onChange={handleInputChange}
                                className="w-full p-2 border rounded"
                            >
                                <option value="">Select Website</option>
                                {websites.map((site) => (
                                    <option key={site.websiteId} value={site.websiteId}>
                                        {site.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {formData.platformType === "app" && (
                        <div>
                            <label className="text-gray-600">Select App</label>
                            <select
                                name="Id"
                                value={formData.Id}
                                onChange={handleInputChange}
                                className="w-full p-2 border rounded"
                            >
                                <option value="">Select App</option>
                                {apps.map((app) => (
                                    <option key={app.id} value={app.id}>
                                        {app.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    <div className="flex justify-end space-x-2">
                        <button
                            type="button"
                            className="px-4 py-2 bg-gray-400 text-white rounded"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded">
                            Assign
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AssignedAdsCode;
